/**
 * Line colours of the spaghetti diagram (ADR 0025), shared by the lazily loaded map and the legend. Kept
 * out of SpaghettiMap so the screen does not pull MapLibre into the main bundle.
 */
import { spaghettiColorSlot } from "@fts/core";

export type SpaghettiColorMode = "vehicles" | "density";

/** Colour token of the i-th vehicle's line (tokens.css --track-1 … --track-10). */
export const spaghettiToken = (index: number) => `--track-${spaghettiColorSlot(index) + 1}`;
/** The single colour of the "density" mode. */
export const SPAGHETTI_DENSITY_TOKEN = "--track-density";
/** Line opacity: vehicle colours, and the single (density) colour, where overlaps build up. */
export const SPAGHETTI_OPACITY = { vehicles: 0.55, density: 0.22 } as const;
